import { type DependencyList, useCallback } from 'react'

import { assert, type ReadonlyRecord } from '../../../../utils'

import { ConnectwareError, ConnectwareErrorType } from '../../../../domain'

import type { CustomizedState } from './Types'

/**
 * Callback for handling ONLY pagination changes for the table component.
 * Use if the table can be changed only by pagination. Other changes will be thrown.
 *
 * @param callback - Function to execute when the 'page' property changes
 * @param deps - Dependencies that control when the callback should be triggered
 */
export const usePageChangeCallback = <T>(
    callback: (state: Extract<CustomizedState<T>, ReadonlyRecord<'page', unknown>>) => void,
    deps: DependencyList
): ((s: CustomizedState<T>) => void) => {
    return useCallback((s: CustomizedState<T>) => {
        assert('page' in s, new ConnectwareError(ConnectwareErrorType.UNEXPECTED, 'Unexpected table customization', s))
        callback(s)
    }, deps)
}
